export const dataSource = [
    // { country: 'France', commodity: 'Nuclear', total: 413278 },
    // // { country: 'Germany', commodity: 'Nuclear', total: 76536 },
    // { country: 'France', commodity: 'Thermal', total: 47594 },
    // // { country: 'Germany', commodity: 'Thermal', total: 375809 },
    // { country: 'France', commodity: 'Wind', total: 21033 },
    // // { country: 'Germany', commodity: 'Wind', total: 58228 },
    // { country: 'France', commodity: 'Solar', total: 7274 },
    // // { country: 'Germany', commodity: 'Solar', total: 37520 },
    // { country: 'France', commodity: 'Tidal, Wave', total: 618 },

    { commodity: 'Nuclear', total: 413278 },
    // { country: 'Germany', commodity: 'Nuclear', total: 76536 },
    {  commodity: 'Thermal', total: 47594 },
    // { country: 'Germany', commodity: 'Thermal', total: 375809 },
    {  commodity: 'Wind', total: 21033 },
    // { country: 'Germany', commodity: 'Wind', total: 58228 },
    {  commodity: 'Solar', total: 7274 },
    // { country: 'Germany', commodity: 'Solar', total: 37520 },
    {  commodity: 'Tidal, Wave', total: 618 },

  ];
  